<template>
  <HXContentCard title="Editar Sucursal" :toBack="{ name: 'Sucursales' }">
    <form @submit.prevent="saveData">
      <div class="row px-5 mt-4">
        <div class="col-md-6">
          <div>
            <label for=" " class="form-label">Nombre Sucursal</label>
            <input v-model="item.descripcion" required placeholder="Escriba el Nombre de la Sucursal..." type="text"
              class="form-control" id=" " />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for=" " class="form-label">Departamento/Estado</label>
            <b-form-select v-if="item.municipio.departamentoPais.id" @change.native="actualizaDepto($event)"
              v-model="item.municipio.departamentoPais.id" required text-field="descripcion" value-field="id"
              :options="ListDepto">
              <template #first>
                <b-form-select-option v-if="selected == null" selected :value="none" disabled>-- Debes seleccionar un
                  país --</b-form-select-option>
                <b-form-select-option v-if="selected != null" selected :value="none" disabled>-- seleccionar
                  Departamento --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for=" " class="form-label">Empresa</label>
            <b-form-select :disabled="usuario.rol.nivel != 4 ? true : false" required v-model="item.empresa.id"
              :options="ListEmpresas" text-field="nombre" value-field="id"></b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for=" " class="form-label">Ciudad/Municipio</label>
            <b-form-select required v-model="item.municipio.id" :options="ListMunicipios" text-field="descripcion"
              value-field="id">
              <template #first>
                <b-form-select-option selected :value="none" disabled>-- Seleccionar Ciudad/Municipio
                  --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-4">
            <label for=" " class="form-label">País</label>
            <b-form-select v-if="item.municipio.pais.id" v-model="item.municipio.pais.id"
              @change.native="actualizaPais($event)" required value-field="id" text-field="descripcion"
              :options="ListPais">
              <template #first>
                <b-form-select-option :value="none" disabled>-- Selecciona un país --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-4">
            <label for="marca" class="form-label">Marca</label>
            <!-- Usar computed property para manejar el v-model de marca -->
            <b-form-select id="marca" v-model="marcaId" :options="ListMarcas" value-field="id" text-field="descripcion"
              :disabled="ListMarcas.length === 0">
              <template #first>
                <b-form-select-option :value="null">-- Selecciona una Marca (opcional) --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="text-right px-5 pb-4 d-flex justify-content-end">
        <vs-button icon animation-type="vertical" type="submit">
          <i class="fas fa-save pr-1"></i>
          Actualizar Sucursal
          <template #animate>
            <i class="fas fa-save"></i>
          </template>
        </vs-button>
      </div>
    </form>
  </HXContentCard>
</template>

<script>
export default {
  data() {
    return {
      item: {
        empresa: {
          id: "",
        },
        municipio: {
          pais: { id: "" },
          departamentoPais: {
            id: "",
          },
        },
        departamento: {
          id: "",
        },
        marca: null, // Inicializar como null en lugar de objeto
      },
      ListPais: [],
      ListMarcas: [],
      ListDepto: [],
      ListMunicipios: [],
      ListEmpresas: [],
      pais: "",
      depto: "",
      selected: null,
      deptoSelected: null,
      ciudadSelected: null,
      municipioSelected: null,
      empresaSelected: null,
      usuario: { rol: { nivel: 0 } },
      id: "",
    };
  },
  computed: {
    // Computed property para manejar el ID de marca de forma segura
    marcaId: {
      get() {
        return this.item.marca ? this.item.marca.id : null;
      },
      set(value) {
        if (value === null) {
          this.item.marca = null;
        } else {
          // Si no existe el objeto marca, crearlo
          if (!this.item.marca) {
            this.item.marca = {};
          }
          this.item.marca.id = value;
        }
      }
    }
  },
  async mounted() {
    try {
      this.$isLoading(true);
      this.id = this.$route.params.id;
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
      console.log("usuario ", this.usuario);

      // Cargar datos principales primero
      await this.getData();

      // Cargar listas de forma paralela para mejorar performance
      await Promise.all([
        this.getPais(),
        this.getMarca(),
        this.getEmpresas()
      ]);

      // Cargar datos dependientes después
      if (this.item.municipio && this.item.municipio.departamentoPais && this.item.municipio.departamentoPais.id) {
        await this.getMunicipio(this.item.municipio.departamentoPais.id);
      }

      if (this.item.municipio && this.item.municipio.pais && this.item.municipio.pais.id) {
        await this.getDepartamento(this.item.municipio.pais.id);
      }

      this.$isLoading(false);
    } catch (error) {
      console.log("error", error);
      this.$isLoading(false);
    }
  },
  methods: {
    async actualizaDepto(e) {
      console.log(e.target.value);
      this.depto = e.target.value;
      await this.getMunicipio(this.depto);
    },
    async actualizaPais(e) {
      console.log(e.target.value);
      this.pais = e.target.value;
      await this.getDepartamento(this.pais);
    },
    async getData() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Sucursal/Get/" + this.id,
        });

        // Asegurar que la estructura de datos sea consistente
        this.item = {
          ...res,
          marca: res.marca || null // Si marca no existe, asignar null
        };

        console.log("list data sucursal* ************* ", this.item);
      } catch (error) {
        this.item = {
          empresa: { id: "" },
          municipio: {
            pais: { id: "" },
            departamentoPais: { id: "" },
          },
          departamento: { id: "" },
          marca: null,
        };
        console.log("err", error);
      }
    },
    async getEmpresas() {
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Empresa/ListEmpresa/",
        });
        this.ListEmpresas = res || [];
        console.log("list", this.ListEmpresas);
      } catch (error) {
        this.ListEmpresas = [];
        console.log("err", error);
      }
    },
    async getPais() {
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Pais/List/",
        });
        this.ListPais = res || [];
        console.log("list", this.ListPais);
      } catch (error) {
        this.ListPais = [];
        console.log("err", error);
      }
    },
    async getDepartamento(pais) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "DepartamentoPais/ListByPais/" + pais,
        });
        this.ListDepto = res || [];
        console.log("ListDepto", this.ListDepto);
      } catch (error) {
        this.ListDepto = [];
        console.log("err", error);
      }
    },
    async getMunicipio(departamentoId) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Municipio/ListByDepartamento/" + departamentoId,
        });
        this.ListMunicipios = res || [];
        console.log("ListMunicipios", this.ListMunicipios);
      } catch (error) {
        this.ListMunicipios = [];
        console.log("err", error);
      }
    },
    async getMarca() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Marca/GetMarca/" + this.usuario.empresa.id,
        });
        if (res && res.data && res.data.length > 0) {
          this.ListMarcas = res.data;
        } else {
          this.ListMarcas = [];
        }
      } catch (error) {
        this.ListMarcas = [];
        console.log("err getMarca", error);
      }
    },
    async saveData() {
      console.log("saving", this.item);
      try {
        this.item.EmpresaId = this.item.empresa.id;
        this.item.municipioId = this.item.municipio.id;

        // Si marca es null, asegurar que se envíe correctamente
        if (!this.item.marca || !this.item.marca.id) {
          this.item.marcaId = null;
        } else {
          this.item.marcaId = this.item.marca.id;
        }

        let res = await this.$store.dispatch("hl_post", {
          path: "Sucursal/Update/",
          data: this.item,
        });
        console.log("post empresas...", res);
        if (res) {
          this.$router.push("/helex/Sucursales");
        } else {
          alert("Verificar");
        }
      } catch (error) {
        console.log("err saveData", error);
        alert("Error al guardar los datos");
      }
    },
  },
};
</script>
